//React Components and Hooks
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
//Material UI Components
import Typography from "@mui/material/Typography";
import React from "react";
import { Link } from "react-router-dom";
//Material UI Icons
//Custom Components
//Context
const StandardHeader = (
  props /*{props, props.title., props.rightSideToolBar, props.appPath}*/
) => {
  const useStyles = makeStyles((theme) => {
    return {
      dropdown: {
        width: "14rem",
      },
      modalcontainer: {
        width: "60%",
        height: "60%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "15px",
        padding: "3rem",
      },
      link: {
        textDecoration: "none",
        color: theme.palette.secondary.main,
        "&:hover": {
          fontWeight: "bold",
          textDecoration: "underline",
        },
      },
      pageEmergencyHeaderFontColor: {
        color: "#ff0000",
        fontWeight: "bold",
      },
      rightSideHeader: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "flex-end",
        flexWrap: "wrap",
      },
      titleText: {
        marginBottom: "5px",
      },
      pathText: {
        marginTop: "5px",
      },
      root: {
        display: "flex",
        justifyContent: "left",
        flexWrap: "wrap",
        "& > *": {
          margin: theme.spacing(0.5),
        },
      },
    };
  });
  const classes = useStyles();
  var headerStyleClass = {};
  if (props.pageEmergency) {
    headerStyleClass = classes.pageEmergencyHeaderFontColor;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%",
        alignItems: "flex-start",
        justifyContent: "space-between",
        columnGap: 2,
        rowGap: 2,
      }}
    >
      <Box sx={{ flex: "1 1 auto", minWidth: 0, maxWidth: "100%" }}>
        <Typography
          variant="h3"
          color="textPrimary"
          className={(classes.titleText, headerStyleClass)}
        >
          {props.title || "UNKNOWN_TITLE"}
        </Typography>
        <div className={classes.root}>
          {props.headerTags && props.headerTags.length > 0 && props.headerTags}
        </div>
        <Breadcrumbs aria-label="breadcrumb" className={classes.pathText}>
          <Link className={classes.link} to="/dashboard">
            UBIL +
          </Link>
          <Typography>
            {props.appPath || props.title || "UNKNOWN_LOCATION"}
          </Typography>
        </Breadcrumbs>
      </Box>
      {props.rightSideToolBar != null && props.rightSideToolBar !== false && (
        <Box className={classes.rightSideHeader} sx={{ flexShrink: 0 }}>
          {props.rightSideToolBar}
        </Box>
      )}
    </Box>
  );
};

export default StandardHeader;
